import { useLayoutContext } from '../Contexts/LayoutContext';
import { useOrderTypeContext } from '../Contexts/OrderTypeContext';
import { useLoginContext } from '../Contexts/LoginContext';
import CustomerService from '../Services/CustomerService';
import { useCartHook } from './CartHook';
import { useAddressHook } from './AddressHook';
import { useStoreContext } from '../Contexts/StoreContext';
import { useStoreHook } from './StoreHook';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TokenManager } from '../Services/TokenManager';

export const useLoginHook = () => {

    const { t } = useTranslation();
    const { company, setMainLoading, setMainLoadingTitle, setMainLoadingMessage } = useLayoutContext();
    const { orderType, isDelivery, isStoreCounter } = useOrderTypeContext();
    const { setUser, setShowLoginStoreCounter } = useLoginContext();
    const { currentAddress } = useStoreContext();
    const { getCustomerCart } = useCartHook();
    const { getLinkToHome } = useStoreHook();
    const { handleCreateAddress } = useAddressHook();

    const navigate = useNavigate();

    const handleSSO = async () => {
        const params = new URLSearchParams(window.location.search);
        const state = params.get('state') || null;
        const session_state = params.get('session_state') || null;
        const code = params.get('code') || null;

        if (state && session_state && code && company) {
            try {
                setMainLoading(true);
                setMainLoadingTitle(t('login.sso_title'));
                setMainLoadingMessage(t('layout.loading_main.default_message'));

                const paramsSSO = {
                    state,
                    session_state,
                    code,
                    hash: company?.hash,
                    guest_token: TokenManager.getGuestToken() || ''
                }
                const customerService = new CustomerService(orderType);
                const response = await customerService.keycloakDecrypt(paramsSSO);

                if (response) {

                    TokenManager.setToken(response.token);
                    setUser(response.customer);

                    if (isStoreCounter) {
                        getCustomerCart();
                    }

                    if (isDelivery && currentAddress) {
                        handleCreateAddress()
                            .then(() => {})
                            .catch(() => {});
                    }

                    //* Redirect
                    handleRedirect();
                }
            } catch (error) {
                window.location.href = getLinkToHome();
            } finally {
                window.history.replaceState({}, '', window.location.pathname);
                setMainLoading(false);
            }
        }
    }

    const handleRedirect = (pageName?: string) => {
        const storedRedirect = localStorage.getItem('redirect');

        if (storedRedirect) {
            if (storedRedirect === 'checkout') {
                //* To checkout
                navigate(`${getLinkToHome()}/checkout`);
            } else if (storedRedirect === 'programa-de-fidelidade') {
                //* To fidelity program
                navigate('/programa-de-fidelidade');
            } else {
                navigate(storedRedirect);
            }
            localStorage.removeItem('redirect');
        } else {
            navigate(pageName || getLinkToHome());
        }
    };
    
    const handleRedirectSSO = () => {
        setShowLoginStoreCounter(false);

        const lang = localStorage.getItem('i18nextLng');
        const redirectPath = `${process.env.REACT_APP_URL_SSO_LOGIN!}?${new URLSearchParams({
            company: company.hash,
            redirect: window.location.pathname,
            ...(lang && { locale: lang }),
            }).toString()}`;

        localStorage.setItem('redirect', window.location.pathname);
        window.location.href = redirectPath;
    };

    return {
        handleSSO,
        handleRedirect,
        handleRedirectSSO
    };
}